var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShowList(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 5.5V9.5C4.5 10.0523 4.94772 10.5 5.5 10.5H9.5C10.0523 10.5 10.5 10.0523 10.5 9.5V5.5C10.5 4.94772 10.0523 4.5 9.5 4.5H5.5C4.94772 4.5 4.5 4.94772 4.5 5.5Z",
    fill: "#222222",
    fillOpacity: 0.9
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 14.5V18.5C4.5 19.0523 4.94772 19.5 5.5 19.5H9.5C10.0523 19.5 10.5 19.0523 10.5 18.5V14.5C10.5 13.9477 10.0523 13.5 9.5 13.5H5.5C4.94772 13.5 4.5 13.9477 4.5 14.5Z",
    fill: "#222222",
    fillOpacity: 0.9
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5 6H19.5",
    stroke: "#222222",
    strokeOpacity: 0.9,
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5 9H19.5",
    stroke: "#222222",
    strokeOpacity: 0.9,
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5 15H19.5",
    stroke: "#222222",
    strokeOpacity: 0.9,
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5 18H19.5",
    stroke: "#222222",
    strokeOpacity: 0.9,
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShowList);
export default __webpack_public_path__ + "static/media/show-list.75795daed4da09dd237eb7ef70f1ca80.svg";
export { ForwardRef as ReactComponent };